import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import ModalButton from '../../../atomic/Buttons/ModalButton';
import QuestionnaireModal from '../../Modals/QuestionnaireModal';
import Icon from '@material-ui/core/Icon';

const ModalButtonStyled = styled(ModalButton)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${props => {
    if (props.alert) {
      return css`
        color: #d8000c;
        background-color: #ffbaba;
      `;
    } else {
      return css`
        color: white;
        background-color: #2bd855;
      `;
    }
  }}
`;

const QuestionnaireButton = ({ questionsAnswers, header, subheader, ...other }) => {
  return (
    <ModalButtonStyled
      variant="contained"
      modalComponent={<QuestionnaireModal 
        questions={questionsAnswers} 
        header={header} 
        subheader={subheader}
        />}
      {...other}
    >
      <Icon>question_answer</Icon> Questions
    </ModalButtonStyled>
  );
};

QuestionnaireButton.propTypes = {
  questionsAnswers: PropTypes.array,
};

export default QuestionnaireButton;
